<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { messageTimestamp } from 'shared/helpers/timeHelper';

import MessageStatus from './MessageStatus.vue';
import Icon from 'next/icon/Icon.vue';
import { useMessageDeliveryStatus } from './useMessageDeliveryStatus';
import { useMessageContext } from './provider.js';

const props = defineProps({
  canonicalTime: { type: Boolean, default: false },
  showTime: { type: Boolean, default: true },
  showDetails: { type: Boolean, default: true },
  showStatus: { type: Boolean, default: true },
});
const { isPrivate, createdAt } = useMessageContext();
const { showStatusIndicator, statusToShow } = useMessageDeliveryStatus();
const { locale } = useI18n();

const readableTime = computed(() =>
  messageTimestamp(
    createdAt.value,
    props.canonicalTime ? 'yyyy/MM/dd HH:mm' : 'LLL d, h:mm a',
    locale.value
  )
);
</script>

<template>
  <div class="text-xs flex items-center gap-1.5">
    <div v-if="showTime" class="inline">
      <time
        class="inline"
        :data-bcw-canonical-time="canonicalTime ? 'true' : undefined"
        >{{ readableTime }}</time
      >
    </div>
    <slot v-if="showDetails" name="afterTime" />
    <Icon
      v-if="showDetails && isPrivate"
      icon="i-lucide-lock-keyhole"
      class="size-3"
    />
    <MessageStatus
      v-if="showDetails && showStatus && showStatusIndicator"
      :status="statusToShow"
    />
  </div>
</template>
`
